import React, { FC } from 'react';
import { defineLoader, httpTaskToResponseTask } from '@core/router/loader';
import { parseQueriesFormUrl } from '@shared/utils/queries';
import * as ZonesService from '@modules/zones/service';
import { getPageQuery } from '@shared/modules/range/utils';
import { SearchFilter, searchFilterParser } from '@shared/modules/filter';
import { useRange, VirtualizedList } from '@shared/modules/range';
import { identity } from 'fp-ts/function';
import { Zone } from '@modules/zones/model';
import Page, { PageProps } from '@layout/page/Page';
import ZonesListRow from '@modules/zones/components/list/row/ZonesListRow';
import { defineRoute } from '@core/router';
import { SharedButtonLink } from '@styles/shared';
import { Stack, Text, ThemeIcon } from '@mantine/core';
import { IconBorderHorizontal } from '@tabler/icons-react';
import { CompanyUserRole } from '@modules/auth/model';
import { useHasRole } from '@modules/auth/hooks';

const loader = defineLoader({
  handler: ({ request }) => {
    const queries = parseQueriesFormUrl(request.url);
    return httpTaskToResponseTask(ZonesService.getZonesRange(getPageQuery(queries), searchFilterParser(queries)));
  },
});

const ZonesListPage: FC = () => {
  const { range, handleLoadPage } = useRange<typeof loader, Zone.Range.Item, SearchFilter>(identity);
  const isAdmin = useHasRole(CompanyUserRole.Admin);

  const pageProps: PageProps = {
    seoTitle: "Zones d'entretien",
    back: { title: "Zones d'entretien", to: '/inputs' },
    bottomBar: isAdmin ? (
      <SharedButtonLink to="new" btnType="create">
        Ajouter une zone d'entretien
      </SharedButtonLink>
    ) : undefined,
  };

  return (
    <Page {...pageProps} bg="background.1" withNav>
      <VirtualizedList
        range={range}
        loadPage={handleLoadPage}
        emptyRender={
          <Stack align="center" ta="center" spacing="lg">
            <ThemeIcon size={95} color="transparent" c="blue.2">
              <IconBorderHorizontal size="100%" />
            </ThemeIcon>
            <Text weight={500}>Vous n’avez aucune zone d’entretien actuellement</Text>
          </Stack>
        }
      >
        {ZonesListRow}
      </VirtualizedList>
    </Page>
  );
};

const zonesListRoute = defineRoute({
  component: ZonesListPage,
  loader,
});

export default zonesListRoute;
